import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import React, { useState } from "react";
import { BuilderAsset } from "../../entities/BuilderAsset";
import { ShareService } from "../../services/ShareService";

interface Props {
    open: boolean;
    onClose: () => void;
    item: BuilderAsset;
    onShareChangeSuccess: (
        id: string,
        isShared: boolean,
        shareId: string
    ) => void;
}

export function NonPaidUnshareDialog(props:Props){
    const [disabled, setDisabled] = useState(false);

    const onConfirmUnshareNonPaid = async (e: React.FormEvent<HTMLElement>) => {
        e.preventDefault();
    
        if (disabled) return;

        setDisabled(true);
        let shareResponse = await ShareService.unshare(props.item.id);
        setDisabled(false);

        if(shareResponse.success){
            props.onShareChangeSuccess(shareResponse.data.id, shareResponse.data.isShared, shareResponse.data.shareId!);
            props.onClose();
        }
      };


    return (
        <Dialog
          open={props.open}
          onClose={props.onClose}
          aria-labelledby="unshare-form-dialog-title"
        >
            <form onSubmit={(e: React.FormEvent<HTMLElement>) => onConfirmUnshareNonPaid(e)}>
                <DialogTitle id="rename-form-dialog-title">
                    Confirm Unshare
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        As a free user, once you stop sharing this resource, you will not
                        be able to share it again unless you upgrade your account. Still
                        want to stop sharing?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose} color="primary" >
                        Cancel
                    </Button>
                    <Button disabled={disabled} type="submit" color="primary" >
                        Unshare
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}